import { SearchTerm } from "./SearchTerm";

const DeviceTimePatternSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "tpName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default DeviceTimePatternSearch;
